<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <CycleSelector :ward-id="Patient.wardId" v-model="cycleSelection" class="pull-right"></CycleSelector>
            </div>

        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3 class="panel-title">
                            Charts <span class="pull-right panel-title"><small> Selected : {{chartSelection.length}} </small></span>
                        </h3>
                    </div>
                    <div class="panel-body">
                        <fieldset>
                            <ChartSelector v-model="chartSelection"></ChartSelector>
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <hr />
            <div class="form-group col-md-4" v-bind:class="{ 'has-error' : hasError}">
                <WorkerButton :disabled="hasError" :submit="Generate" disable-toast="true" name="Generate"></WorkerButton>
                <a href="#" class="btn btn-warning disabled">Reset</a>
                <span class="help-block" v-if="hasError">
                    <small>{{message}}</small>
                </span>
            </div>
        </div>
    </div>

</template>


<script>
    import PatientSelector from "../PatientSelector/PatientSelector.scp.html";
    import ChartSelector from "../ChartSelector/ChartSelector.scp.html";
    import CycleSelector from "../CycleSelector/CycleSelector.scp.html";
    import CarehomeHeader from "../CarehomeHeader/CarehomeHeader.scp.html";
    import WardSelector from "../WardSelector/WardSelector.scp.html";
    import WorkerButton from "../../corecontrols/workerbutton/workerbutton.scp.html";

    import Dal from './../../../scripts/dataaccess'

    export default {
        props: {
            patientid: {
                type: String,
                required: false
            },
            carehomeid: {
                type: String,
                required: true
            }
        },
        data: function () {
            return {
                carehome: {},
                IsLabelsSelected: false,

                patientSelection: [],
                chartSelection: [],
                cycleSelection: {},

                hasError: true,
                message: "",
                Patient: {}
            }
        },
        watch: {
            patientSelection: function () { this.CheckState() },
            chartSelection: function () { this.CheckState() }
        },
        mounted: function () {

            console.log("Charts mounted with ", this.carehomeid, this.wardid, this.patientid)

            var dal = new Dal();
            if (this.patientid) {
                dal.GetPatient(this.patientid).then(data => {
                    this.Patient = data;

                })

            }

            this.CheckState();
        },
        methods: {
            CheckState: function () {
                this.hasError = false;
                if (this.chartSelection.length == 0) {
                    this.hasError = true;
                    this.message = "Select atleast one chart"
                    return;
                }
            },
            Generate: function () {

                var pids = [];
                var charts = [];

                pids.push(this.Patient.pharmacyPatientId);

                console.log(this.cycleSelection);
                var startDate = this.cycleSelection.startDate;
                var endDate = this.cycleSelection.endDate;

                var dal = new Dal();
                return dal.GenerateReports(pids, this.chartSelection, startDate, endDate)
            }
        },
        components: {
            PatientSelector,
            ChartSelector,
            CycleSelector,
            CarehomeHeader,
            WardSelector,
            WorkerButton
        }
    }
</script>


// WEBPACK FOOTER //
// PatientChartForm.scp.html?4e5a8825